import * as React from 'react';
export const usbankSvg = React.forwardRef(function usbankSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#DE162B',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M5.19 21.17V8.65H26.8v12.52L16 25.08 5.19 21.17zm16.26-7.77a1 1 0 0 1 .37.68h3.03c-.04-2.29-2.3-2.84-4.17-2.84-1.73 0-4.08.6-4.08 2.88 0 1.52 1.01 2.37 3.52 2.83 1.5.3 1.82.42 1.82.93 0 .55-.69.72-1.13.72-.37 0-.7-.13-.85-.25-.29-.21-.4-.47-.45-.8H16.4c.08 2.36 2.26 3.2 4.28 3.2 2.15 0 4.37-.71 4.37-3.2 0-1.44-.97-2.08-2.02-2.46-1.1-.46-2.35-.46-2.91-.72-.16-.12-.37-.25-.37-.5 0-.6.53-.72.97-.72.25 0 .53.08.73.25zm-5.92 7.1h.04v-9.26H12.4v4.9c0 1.56-.7 1.82-1.25 1.82-.94 0-1.06-.78-1.06-1.83v-4.89H6.92v6.33c0 2.18 1.37 3.19 2.86 3.19 1.25 0 2.1-.48 2.7-1.44v1.17h3.05z',
      }),
    ),
  );
});
usbankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var usbank = {
  category: 'brand',
  colorable: false,
  name: 'usbank',
  svg: usbankSvg,
};
